(function (window, document) {
  'use strict';

  let cookies = document.cookie.split(('; '));
  let wrapper;

  const init = () => {
    const wrappers = document.querySelectorAll('.vodl-region-hyperlocal-wrapper.pre-init');
    wrappers.forEach( current_wrapper => {
      wrapper = current_wrapper;
      initHyperlocalBoxWrapper();
    });
  };

  const initHyperlocalBoxWrapper = () => {
    let url;

    for (let i = 0; i <= cookies.length; i++) {
      if (cookies[i] !== undefined) {

        let name = cookies[i].split('=')[0];

        if (name === 'CurrentCity') {
          let value = cookies[i].split('=')[1];
          url = '/api/nnp/get_hyperlocal?t=' + value;
          break;
        }
      }
    }

    if (url !== undefined) {
      getData(url);
    }
    wrapper.addEventListener('gemeindechanged', onChange);
    wrapper.classList.remove('pre-init');
  };

  const getData = ( url ) => {
    axios
      .get(url)
      .then(response => done(response.data))
      .catch(err => error(err));
  };

  const onChange = () => {
    let town = document.querySelector('.vodl-select-region__current').getAttribute('data-mytown-slug'),
      url  = '/api/nnp/get_hyperlocal?t=' + town;

    getHyperlocal(url);
  };

  const error = (err) => {
    console.log('vodl-region-hyperlocal: something went wrong', err);
  };

  const done = (data) => {
    wrapper.innerHTML = data;
    vodlInitSelectRegion();
  };

  document.addEventListener('DOMContentLoaded', init );
  window.addEventListener('newPage', init, false);

})(window, document);
